import React from 'react';
import { useAppContext } from '../../context/AppContext';

/**
 * CompanyLogo — the tenant/company logo shown in the top-left sidebar slot.
 *
 * Purely image-driven: the logo is uploaded in Settings → Config Items and
 * stored in tenant config (`company_logo`, a base64 data URL). If none is set,
 * nothing renders — any company name/tagline is expected to be part of the image
 * itself. Sits on the always-white sidebar brand box.
 */
export default function CompanyLogo({ collapsed = false }) {
  const { config } = useAppContext();
  const logo = config?.company_logo;

  if (!logo) return null;

  return (
    <img
      src={logo}
      alt="Company logo"
      className={`object-contain ${collapsed ? 'h-8 w-8' : 'h-9 max-w-[120px]'}`}
    />
  );
}
